import type { FaireProductEntity } from "../../entity_types/product";

export const p_2nt23mdfn8: FaireProductEntity = {
  token: "p_2nt23mdfn8",
  type: "product",
  name: "A Year By the Sea Little Wall Calendar",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/85e5decc7d1e77e8633781c3de0b2b63e65513170a8a4ecd731e74a0ff592fe8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6800adf4a5d82787284bb867c5210b504637ae04128f8818edbf23b2929fa584.jpeg",
    "https://cdn.faire.com/fastly/e5436d4acc73ac2ecb55d61b72df5255c4be512cfd20614264332ce7fa7dbdc9.jpeg",
    "https://cdn.faire.com/fastly/ea2e557c90f0ebb623dc3d299a9325d79e6c9a6936ff4e7a48c3fa93cbe7465d.jpeg",
    "https://cdn.faire.com/fastly/b6c20aa3612f451a953b006913d4a46540cd1d0653b3e74c13fa367a509e8d77.jpeg",
  ],
  priceDollars: 13,
  description:
    "It's normal, we tell ourselves, to occasionally forget what month it is. Or year :) So we made this wall-hanging beauty for easy reference. Spend a year by the sea, with each month offering a gorgeous, salty-air painting to make your home or office feel that sunwashed bliss of the coast. Wait a sec... it's MAY?!!\n\n6\" x 9\"",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:40.399Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
